export default "__VITE_ASSET__BfF1V2TS__"